import { create } from 'zustand'

export type BatchInfo = {
  batchName: string
  startDate: number
}

export type BatchState = { [batchId: string]: BatchInfo }

type BatchStore = {
  batches: BatchState
  setBatches: (batches: BatchState) => void
  addBatch: (batchId: string, batchInfo: BatchInfo) => void
  updateBatch: (batchId: string, batchInfo: BatchInfo) => void
  delBatch: (batchId: string) => void
}

const initialBatchState: BatchState = {
  $unbatched: { batchName: 'Unbatched Tanks', startDate: 0 },
  $empty: { batchName: 'Empty Tanks', startDate: 0 },
}

export const useBatchStore = create<BatchStore>((set) => ({
  batches: initialBatchState,
  setBatches: (batches) => {
    set(() => ({ batches }))
  },
  addBatch: (batchId, batchInfo) => {
    set((state) => ({
      batches: {
        ...state.batches,
        [batchId]: batchInfo,
      },
    }))
  },
  updateBatch: (batchId, batchInfo) => {
    set((state) => ({
      batches: {
        ...state.batches,
        [batchId]: batchInfo,
      },
    }))
  },
  delBatch: (batchId) => {
    set((state) => {
      const newBatches = { ...state.batches }
      delete newBatches[batchId]
      return { batches: newBatches }
    })
  },
}))
